import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IKhoLeadActionTypes } from "../../action-types/crm-survey/IKhoLeadActionTypes";
import { IKhoLeadReducer } from "../../page-state-model/crm-survey/IKhoLeadReducer";

const iniState: IKhoLeadReducer = {
    status: ePageBaseStatus.is_not_initialization,
    leads: [],
    thongKes: [],
    roundRobins: [],
};

export const khoLeadReducer = (
    state: IKhoLeadReducer = iniState,
    action: IKhoLeadActionTypes
): IKhoLeadReducer => {
    switch (action.type) {
        case "KHO_LEAD_LOAD_START":
            return { ...state, status: ePageBaseStatus.is_loading };
        case "KHO_LEAD_LOAD_SUCCESS":
            return { ...state, status: ePageBaseStatus.is_completed, leads: action.payload };
        case "KHO_LEAD_LOAD_ERROR":
            return { ...state, status: ePageBaseStatus.is_completed, leads: [] };

        case "KHO_LEAD_LOAD_THONGKE_SUCCESS":
            return { ...state, thongKes: action.payload };
        case "KHO_LEAD_LOAD_THONGKE_ERROR":
            return { ...state, thongKes: [] };

        case "KHO_LEAD_LOAD_ROUNDROBIN_SUCCESS":
            return { ...state, roundRobins: action.payload };
        case "KHO_LEAD_LOAD_ROUNDROBIN_ERROR":
            return { ...state, roundRobins: [] };

        case "KHO_LEAD_DELETE_START":
            return { ...state, status: ePageBaseStatus.is_deleting };
        case "KHO_LEAD_DELETE_SUCESS":
            return { ...state, status: ePageBaseStatus.is_need_reload };
        case "KHO_LEAD_DELETE_ERROR":
            return { ...state, status: ePageBaseStatus.is_completed };

        case "KHO_LEAD_NEED_RELOAD":
            return { ...state, status: ePageBaseStatus.is_need_reload };

        default:
            return state;
    }
};
